"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var react_redux_1 = require("react-redux");
var core_1 = require("@material-ui/core");
var lab_1 = require("@material-ui/lab");
var StatusBarCompletedIcon_1 = __importDefault(require("../../../widgets/StatusBarCompletedIcon"));
var StatusBarFailedIcon_1 = __importDefault(require("../../../widgets/StatusBarFailedIcon"));
var StatusBarInProgressIcon_1 = __importDefault(require("../../../widgets/StatusBarInProgressIcon"));
var actions_1 = __importDefault(require("../../../actions"));
var appMargins_1 = __importDefault(require("../../../../app/components/AppMargins/appMargins"));
var types_1 = require("../../../reducers/types");
var CloseButton_1 = __importDefault(require("../../../widgets/CloseButton"));
var DownloadBulkButton_1 = __importDefault(require("../DownloadBulkButton"));
var useStyles = (0, core_1.makeStyles)(function (theme) {
    var _a;
    return (0, core_1.createStyles)({
        error: {
            backgroundColor: '#FFEDED',
            color: theme.palette.text.primary,
        },
        info: {
            backgroundColor: '#FDF3E8',
            color: theme.palette.text.primary,
        },
        success: {
            backgroundColor: '#EAF9E7',
            color: theme.palette.text.primary,
        },
        content: (_a = {
                alignItems: 'stretch',
                paddingTop: theme.spacing(2),
                paddingBottom: theme.spacing(2)
            },
            _a[theme.breakpoints.up('md')] = {
                paddingRight: function (props) { return props.appMargins; },
                paddingLeft: function (props) { return props.appMargins; },
            },
            _a[theme.breakpoints.down('sm')] = {},
            _a),
        message: {},
        messageBody: {
            color: '#767676',
        },
        closeButton: {
            marginRight: theme.spacing(2.5),
        },
        iconWrapper: {
            width: '16px',
            height: '16px',
        },
    });
});
var StatusBar = function () {
    var appMargins = (0, appMargins_1.default)();
    var classes = useStyles({ appMargins: appMargins });
    var _a = __read((0, react_1.useState)(true), 2), showStatusBar = _a[0], setShowStatusBar = _a[1];
    var statusBarMessage = (0, react_redux_1.useSelector)(function (state) { return state.user.statusBarMessage; });
    var header = statusBarMessage.header, body = statusBarMessage.body, callbacks = statusBarMessage.callbacks, variant = statusBarMessage.variant;
    var hasStatusBarAlert = !!(header || body);
    var dispatch = (0, react_redux_1.useDispatch)();
    var colorClass = '';
    var icon = react_1.default.createElement(react_1.default.Fragment, null);
    switch (variant) {
        case types_1.StatusBarVariant.Error:
            colorClass = classes.error;
            icon = react_1.default.createElement(StatusBarFailedIcon_1.default, null);
            break;
        case types_1.StatusBarVariant.Info:
            colorClass = classes.info;
            icon = react_1.default.createElement(StatusBarInProgressIcon_1.default, null);
            break;
        case types_1.StatusBarVariant.Success:
            colorClass = classes.success;
            icon = react_1.default.createElement(StatusBarCompletedIcon_1.default, null);
            break;
        default:
            break;
    }
    var dispatchCloseStatusBar = function () {
        dispatch(actions_1.default.closeStatusBar());
        // store last acknowledged message
        localStorage.setItem('statusBarMessage', JSON.stringify(statusBarMessage));
    };
    var getLatestJob = function () { return dispatch(actions_1.default.getLatestJob()); };
    (0, react_1.useEffect)(function () {
        getLatestJob();
    }, []);
    (0, react_1.useEffect)(function () {
        if (header && body) {
            var localStatusBarMessage = localStorage.getItem('statusBarMessage');
            var statusBarMessageString = JSON.stringify(statusBarMessage);
            if (localStatusBarMessage === statusBarMessageString) {
                // if current message is same as last acknowledged message, hide
                setShowStatusBar(false);
            }
            else {
                // current message has not been acknowledged before
                setShowStatusBar(true);
            }
        }
    }, [header, body]);
    return (react_1.default.createElement(react_1.default.Fragment, null, showStatusBar && hasStatusBarAlert && (react_1.default.createElement(lab_1.Alert, { icon: icon, className: "".concat(colorClass, " ").concat(classes.content), action: react_1.default.createElement(react_1.default.Fragment, null,
            variant === types_1.StatusBarVariant.Success &&
                callbacks.length >= 0 && (react_1.default.createElement(DownloadBulkButton_1.default, { bulkCsvIds: callbacks })),
            variant !== types_1.StatusBarVariant.Info && (react_1.default.createElement(CloseButton_1.default, { onClick: dispatchCloseStatusBar }))) },
        react_1.default.createElement(lab_1.AlertTitle, null, header),
        react_1.default.createElement(core_1.Typography, { variant: "caption", className: classes.messageBody }, body)))));
};
exports.default = StatusBar;
